import { useState, useEffect } from "react";
import Cash from "../assets/cashPayment.svg";
import Bank from "../assets/bankTransfer.svg";
import Card from "../assets/creditCard.svg";
import { CreditCard } from "@mui/icons-material";
const SubscriptionAndPricing = () => {
  return (
    <div>
      <div className="text-xl font-semibold">Additional Information</div>
      <div className="mt-4">
        Add terms and conditions to complete your invoice.
      </div>

      <div className="mb-3 mt-5">
        <div className="text-[#191919] font-semibold mb-4">
          Subscription Description
        </div>
        <input
          type="text"
          placeholder="Enter Subscription Description here"
          className="w-full border border-solid border-[#E4E4E4] py-[10px] px-3 rounded-[8px]"
        />
      </div>
      <div className="flex items-center gap-20 ">
        <div className="flex-1">
          <div className="text-[#191919] font-semibold mb-4">Quantity</div>
          <input
            type="text"
            placeholder="Enter Subscription Duration"
            className="w-full border border-solid border-[#E4E4E4] py-[10px] px-3 rounded-[8px]"
          />
        </div>
        <div className="flex-1">
          <div className="text-[#191919] font-semibold mb-4">Amount</div>
          <input
            type="text"
            placeholder="Enter Subscription Amount"
            className="w-full border border-solid border-[#E4E4E4] py-[10px] px-3 rounded-[8px]"
          />
        </div>
        <div className="flex-1">
          <div className="text-[#191919] font-semibold mb-4">Tax</div>
          <input
            type="text"
            placeholder="Enter Tax"
            className="w-full border border-solid border-[#E4E4E4] py-[10px] px-3 rounded-[8px]"
          />
        </div>
        <div className="flex-1">
          <div className="text-[#191919] font-semibold mb-4">Discount</div>
          <input
            type="text"
            placeholder="Enter Discount"
            className="w-full border border-solid border-[#E4E4E4] py-[10px] px-3 rounded-[8px]"
          />
        </div>
      </div>
      <div className="flex items-center gap-20 mt-4">
        <div className="flex-1">
          <div className="text-[#191919] font-semibold mb-4">
            Invoice Issue Date
          </div>
          <input
            type="text"
            placeholder="Issue Date"
            className="w-full border border-solid border-[#E4E4E4] py-[10px] px-3 rounded-[8px]"
          />
        </div>
        <div className="flex-1">
          <div className="text-[#191919] font-semibold mb-4">
            Invoice Due Date
          </div>
          <input
            type="text"
            placeholder="Due Date"
            className="w-full border border-solid border-[#E4E4E4] py-[10px] px-3 rounded-[8px]"
          />
        </div>
      </div>
      <div className="mt-4">
        <div className="text-[#191919] font-semibold mb-5">Payment Method</div>
        <div className="flex items-center gap-12">
          <div className="w-[190px] h-[40px] flex items-center justify-center gap-2 text-sm text-[#797979] border border-solid border-[#E4E4E4] rounded-[8px]">
            <img src={Cash} alt="cash-icon" /> Cash
          </div>
          <div className="w-[190px] h-[40px] flex items-center justify-center gap-2 text-sm text-[#797979] border border-solid border-[#E4E4E4] rounded-[8px]">
            <img src={Bank} alt="bank-icon" /> Bank Transfer
          </div>
          <div className="w-[190px] h-[40px] flex items-center justify-center gap-2 text-sm text-[#797979] border border-solid border-[#E4E4E4] rounded-[8px]">
            <img src={Card} alt="credit-card" /> Credit Card
          </div>
          <div className="w-[190px] h-[40px] flex items-center justify-center text-sm text-[#797979] border border-solid border-[#E4E4E4] rounded-[8px]">
            Other
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionAndPricing;
